<h3 mat-dialog-title class="headline">Zeitraum auswählen</h3>
<app-detail-list-template [Data]="bvsForm$| async" [Editing]="true" [Inline]="true"> </app-detail-list-template>
<mat-dialog-actions class="actions">
    <button app-button Inverted mat-dialog-close Color="cancel">Abbrechen</button>
    <button app-button [Disabled]="form.invalid" Color="green" (click)="openExportBvs()">Öffnen</button>
</mat-dialog-actions>
